import moment from 'moment';
import { INFOR_CAR } from 'src/app/constant/config';
import { formatMemoryStatus } from 'src/app/components/popupInfocar/memoryStatus';
import { INFO_BOX_MAP, PHONE_QUERY_REGEX, SEARCH_HISTORY_KEY } from './constants';

export const loadSearchHistory = () => {
  try {
    const list = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY));
    return Array.isArray(list) ? list.filter(item => typeof item === 'string') : [];
  } catch (e) {
    return [];
  }
};

export const saveSearchHistory = list => {
  try {
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(list));
  } catch (e) {
    // localStorage bị chặn / đầy -> bỏ qua, lịch sử chỉ còn trong phiên
  }
};

export const getSocketOrigin = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return backendUrl.replace(/\/?api\/?$/, '');
};

// Bỏ khoảng trắng . - trong SĐT người dùng nhập
export const normalizePhoneQuery = q => q.replace(/[\s.-]/g, '');
export const isPhoneQuery = q => PHONE_QUERY_REGEX.test(normalizePhoneQuery(q));

export const formatVehicleFieldValue = (vehicle, dataKey) => {
  const v = vehicle || {};
  switch (dataKey) {
    case 'license_plate':
      return v.license_plate || '--';
    case 'custom_name':
      return v.name?.trim() ? v.name : '--';
    case 'created_at':
      return v.created_at ? moment(v.created_at * 1000).format('HH:mm:ss DD/MM/YYYY') : '--';
    case 'coordinates':
      return v.lat != null && v.lng != null ? `${v.lat}, ${v.lng}` : '--';
    case 'location':
      return v.location || '--';
    case 'speed_gps':
      return v.speed_gps != null ? `${Math.floor(v.speed_gps)} Km/h` : '--';
    case 'max_speed':
      return v.max_speed != null ? `${Math.floor(v.max_speed)} Km/h` : '--';
    case 'daily_distance':
      return v.daily_distance != null ? `${v.daily_distance} Km` : '--';
    case 'total_distance':
      return v.total_distance != null ? `${v.total_distance} Km` : '--';
    case 'stop_duration':
      return v.stop_duration;
    case 'engine_status':
      return v.engine_status != null ? (v.engine_status ? 'Bật' : 'Tắt') : '--';
    case 'battery':
      return v.battery != null ? `${v.battery} ${v.device_type === 'VGPS_MAG4G' ? '%' : 'V'}` : '--';
    case 'device_type':
      return v.device_type || '--';
    case 'serial':
      return v.serial || '--';
    case 'firmware_version':
      return v.firmware_version ? `${v.hardware_version || '--'} / ${v.firmware_version}` : '--';
    case 'imei_sim':
      return v.imei_sim || '--';
    case 'sim':
      return v.sim || '--';
    case 'active_at': {
      if (!v.active_at) return '--';
      const formattedActiveAt = moment(v.active_at).format('DD/MM/YYYY');
      const remainingDays =
        v.date_debt && moment(v.date_debt).isValid()
          ? Math.max(moment(v.date_debt).diff(moment(), 'days'), 0)
          : null;
      return remainingDays != null
        ? `${formattedActiveAt} (Còn: ${remainingDays} ngày)`
        : formattedActiveAt;
    }
    case 'agency_name':
      return v.agency_name || '--';
    case 'fuel_sensor_val':
      if (v.oil_level == null) return '--';
      return v.oil_type ? `${v.oil_level} %` : v.oil_level;
    case 'memory_card':
      return formatMemoryStatus(v.memory_card);
    case 'gsm_level':
      return `${v.gsm_signal ?? '--'} / ${v.satellites ?? '--'}`;
    case 'driver_name':
      return v.driver_name || '--';
    case 'driver_license':
      return v.driver_license === 'VGPS' || v.driver_name === 'Lái xe đăng xuất'
        ? '--'
        : v.driver_license || '--';
    case 'driver_phone':
      return v.driver_phone || '--';
    case 'non_stop_driving_time':
      return v.non_stop_driving_time || '--';
    case 'total_overspeed':
      return v.total_overspeed != null ? `${v.total_overspeed} lần` : '--';
    case 'stop_times':
      return v.stop_times != null ? `${v.stop_times} lần` : '--';
    default:
      return v[dataKey] ?? '--';
  }
};

export const buildVehicleInfoSections = vehicle => {
  const deviceType = vehicle?.device_type;
  const infoBox = INFO_BOX_MAP[deviceType] || INFOR_CAR;
  const oilMap = vehicle?.oil_map;
  const hasOilChart = Array.isArray(oilMap) && oilMap.length > 1;
  const isFuelDevice = ['VGPS_CAR4G', 'VGPS_2CAM', 'VGPS_4CAM'].includes(deviceType);

  const vehicleItems = (infoBox[0] || []).filter(
    item => item.dataKey !== 'activity_chart' || hasOilChart
  );
  const deviceItems = (infoBox[1] || []).filter(
    item => item.dataKey !== 'fuel_sensor_val' || isFuelDevice
  );
  const driverItems = (infoBox[2] || []).filter(
    item => item.dataKey !== 'status_transmission'
  );

  const sections = [
    { key: 'vehicle', title: 'Phương tiện', items: vehicleItems },
    { key: 'device', title: 'Thiết bị', items: deviceItems }
  ];
  if (driverItems.length > 0) {
    sections.push({ key: 'driver', title: 'Lái xe', items: driverItems });
  }
  return sections;
};
